module.exports = __webpack_public_path__ + "img/ai-yellow.2675ec94.png";